// extracted by mini-css-extract-plugin
module.exports = {"container":"_2RBzzzHs9y6r-TIN5BaPrA"};